import { render, staticRenderFns } from "./PlayerGeneralMuscleSorenessChart.vue?vue&type=template&id=a806ae1e"
import script from "./PlayerGeneralMuscleSorenessChart.vue?vue&type=script&lang=js"
export * from "./PlayerGeneralMuscleSorenessChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports